import { render, staticRenderFns } from "./PersonnelRecordDetailsTabGeneral.vue?vue&type=template&id=306624dc"
import script from "./PersonnelRecordDetailsTabGeneral.vue?vue&type=script&lang=js"
export * from "./PersonnelRecordDetailsTabGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports